import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DIAMOND, GOLD, PLATINUM, SILVER } from "../../config/constants";
import { createPseudoActiveMembership } from "../helpers";
import { IUser, resetAuthUserRole, setAuthUserRole } from "./authReducer";
import { resetActiveMembership, setActiveMembership } from "./ordersReducer";
import { IRole } from "./rolesReducer";

export interface IImitationsState {

}

const initialState = {

} as IImitationsState;

const imitationsSlice = createSlice({
    name: 'imitations',
    initialState,
    reducers: {
        imitateCustomer: (state: IImitationsState, action: PayloadAction<{ customerRole: IRole, membershipType?: string }>) => {

        },
        imitateWorker: (state: IImitationsState, action: PayloadAction<{ workerRole: IRole }>) => {

        },
    }
});

export const {
    imitateCustomer,
    imitateWorker,
} = imitationsSlice.actions;


interface ITryImitateCustomerArg {
    user: IUser;
    customerRole: IRole;
    membershipType?: string;
}

export const tryImitateCustomer = createAsyncThunk('imitations/tryImitateCustomer', (arg: ITryImitateCustomerArg, { dispatch }) => {

    const { customerRole, membershipType, user } = arg;

    dispatch(setAuthUserRole(customerRole));

    if (membershipType) {
        //construct the membership plan
        const activeMembership = createPseudoActiveMembership(membershipType, user);

        dispatch(setActiveMembership(activeMembership));
    } else {
        dispatch(setActiveMembership(null));
    }
});

interface ITryImitateWorkerArg {
    workerRole: IRole;
}

export const tryImitateWorker = createAsyncThunk('imitations/tryImitateWorker', (arg: ITryImitateWorkerArg, { dispatch }) => {
    const { workerRole } = arg;

    dispatch(setAuthUserRole(workerRole));
});

export const stopImitation = createAsyncThunk('imitations/stopImitation', (arg: { user: IUser }, { dispatch }) => {
    dispatch(resetAuthUserRole());
    dispatch(resetActiveMembership());
});

export default imitationsSlice.reducer;